export const en = {
  members: 'Members',
  membersAndGuests: 'Members & Clients',
  visibleTo: 'VISIBLE TO',
  visibleToAllGuests:
    'Enabling will make this task visible to all clients in this project.',
  cancel: 'Cancel',
  enable: 'Enable',
  dontShowAgain: "Enable and don't show this again",
  guestWatchersAlertMessage: 'This merged task is visible to ',
  membersOnly: 'Members only.',
  allowClients:
    'To allow your Clients to see this task, make the task visible to ',
  membersAndClients: 'Members & Clients.'
};

export type Translations = typeof en;
